module.exports = __webpack_public_path__ + "img/pr-12.f2902f2c.png";